import type { Article } from "../types";

export function selectVisualStories(articles: Article[]) {
  const illustrated = articles.filter(article => Boolean(article.media?.url));
  return {
    lead: illustrated[0] ?? articles[0],
    starters: illustrated.slice(1, 4),
  };
}
